<div class="product-item">
  <div class="product-item-info">
    <div
      [ngClass]="{ 'is-out-of-stock': isOutOfStock }"
      class="product-image"
      [matBadge]="orderItem.quantity"
      [ngStyle]="styles"
    ></div>
    <div class="product-details">
      <div class="product-title" [ngClass]="{ 'text-disabled': isOutOfStock }">
        {{ orderItem.product?.title }}
      </div>
      <div class="product-item-price">
        @if(!!salePriceOutcome) {
        <span class="price" [ngClass]="{ 'text-disabled': isOutOfStock }">{{
          salePriceOutcome | number : "1.0-2" | currency : "USD" : "symbol"
        }}</span>
        <span
          [ngClass]="{ 'text-disabled': isOutOfStock }"
          class="striked-price"
          >{{
            priceOutcome | number : "1.0-2" | currency : "USD" : "symbol"
          }}</span
        >
        } @else {
        <span class="price" [ngClass]="{ 'text-disabled': isOutOfStock }">{{
          priceOutcome | number : "1.0-2" | currency : "USD" : "symbol"
        }}</span>
        }
      </div>
    </div>
  </div>
  @if (isOutOfStock) {
  <lib-bar-tag
    [oneLineEllipsis]="false"
    [className]="'item-out-of-stock'"
    [icon]="'Block'"
    text="Out of Stock: This item will not be included until more stock is available."
    [spanStyle]="{ marginLeft: '8px', fontWeight: '500' }"
  />
  }
</div>
